
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Alertes = lazy(() => import('../pages/alertes/page'));
const About = lazy(() => import('../pages/about/page'));
const Mission = lazy(() => import('../pages/mission/page'));
const Methodologie = lazy(() => import('../pages/methodologie/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const MentionsLegales = lazy(() => import('../pages/mentions-legales/page'));
const PolitiqueConfidentialite = lazy(() => import('../pages/politique-confidentialite/page'));
const PolitiqueCookies = lazy(() => import('../pages/politique-cookies/page'));
const ArticleDetail = lazy(() => import('../pages/article/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/article/:slug',
    element: <ArticleDetail />,
  },
  {
    path: '/mobilisations',
    element: <Alertes />,
  },
  {
    path: '/a-propos',
    element: <About />,
  },
  {
    path: '/notre-mission',
    element: <Mission />,
  },
  {
    path: '/methodologie-independance',
    element: <Methodologie />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegales />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialite />,
  },
  {
    path: '/politique-cookies',
    element: <PolitiqueCookies />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
